import { render, staticRenderFns } from "./QuickDeclareQuerySidePanel.vue?vue&type=template&id=b06cac64&"
import script from "./QuickDeclareQuerySidePanel.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareQuerySidePanel.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareQuerySidePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports